module.exports = __webpack_public_path__ + "static/media/home-changing-4.00f4ca29.jpg";